import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Tab, Tabs } from '../../../components/Tabs';
import { Routing } from '../../../../util/routes.util';
import DisplaySettingsDetailPane from './Panes/DisplaySettingsDetailPane';
import DisplaySettingsCustomTranslationsPane from './Panes/DisplaySettingsCustomTranslationsPane';
import { t } from '../../../../types/translation/Translator';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { CompanyRoleAssignmentContext } from '../../../../context/CompanyRoleAssignmentContext';

export default function DisplaySettingsScreen() {
  const { isAdmin } = useContext(CompanyRoleAssignmentContext);

  if (!isAdmin) return <Navigate to={Routing.settings.stockLocations.overview()} />;

  return (
    <div className='content-x content-y-screen flex h-full flex-grow flex-col'>
      <Tabs>
        <Tab
          text={t(TranslationKey.companyDetailsTab).singular.upper}
          path={Routing.settings.display.details()}
          key={'details'}
        />
        <Tab
          text={t(TranslationKey.customTranslationsTab).singular.upper}
          path={Routing.settings.display.customTranslations()}
          key={'custom_translations'}
        />
      </Tabs>
      <Routes>
        <Route path={'details'} element={<DisplaySettingsDetailPane />} />
        <Route path={'custom_translations'} element={<DisplaySettingsCustomTranslationsPane />} />
      </Routes>
    </div>
  );
}
